import { baseWhite, themePrimary } from 'shared/utils/cssUtility';
import { SvgIconType } from './svg.interface';

const NotificationIconCircle: SvgIconType = ({
  width = 56,
  height = 56,
  className = '',
  circleColor = themePrimary,
  color = baseWhite
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="28" cy="28" r="28" fill={circleColor} />
    <path
      d="M39.421 32.2217L37.1875 29.9587V22.4875C37.1875 17.4134 33.0741 13.3 28 13.3C22.9259 13.3 18.8125 17.4134 18.8125 22.4875V29.9587L16.579 32.2217C16.2396 32.5656 16.0493 33.0293 16.0493 33.5125C16.0493 34.5273 16.872 35.35 17.8868 35.35H38.1132C38.5964 35.35 39.0601 35.1597 39.404 34.8203C40.1262 34.1074 40.1339 32.944 39.421 32.2217Z"
      fill={color}
    />
    <path
      d="M28 42.7C30.2224 42.7 32.0762 41.1218 32.5019 39.025H23.4981C23.9238 41.1218 25.7776 42.7 28 42.7Z"
      fill={color}
    />
  </svg>
);

export default NotificationIconCircle;
